// extracted by mini-css-extract-plugin
module.exports = {"root":"banner_root__1rYW0","container":"banner_container__25_2v","imageContainer":"banner_imageContainer__3u0PI","text":"banner_text__3AlmP"};